import { render } from "./CategoryServiceEndoscopy.vue?vue&type=template&id=69f386cc&scoped=true&ts=true"
import script from "./CategoryServiceEndoscopy.vue?vue&type=script&lang=ts"
export * from "./CategoryServiceEndoscopy.vue?vue&type=script&lang=ts"

import "./CategoryServiceEndoscopy.vue?vue&type=style&index=0&id=69f386cc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f386cc"]])

export default __exports__